import { CompanySchema } from "@repo/validators";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { SettingsHeader } from "~/components/layout/settings-header";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  useForm,
} from "~/components/ui/form";
import { Input } from "~/components/ui/input";
import { useUser } from "~/hooks/use-user";

export const Route = createFileRoute("/_main/settings/_layout/company")({
  component: Company,
});

function Company() {
  const { t, i18n } = useTranslation("common");
  const { user } = useUser();
  const form = useForm({
    schema: CompanySchema(i18n),
    defaultValues: {
      companyName: user.companyName,
      cocNumber: user.cocNumber,
      zipCode: user.zipCode,
      streetName: user.streetName,
      streetNumber: user.streetNumber,
      country: user.country,
      city: user.city,
      phoneNumber: user.phoneNumber,
      email: user.email,
      website: user.website,
    },
  });
  return (
    <>
      <SettingsHeader title={t("company")} />
      <Form {...form}>
        <form className="flex flex-col gap-4">
          <Card>
            <CardHeader>
              <CardTitle>{t("Company.general_title")}</CardTitle>
              <CardDescription>
                {t("Company.general_description")}
              </CardDescription>
            </CardHeader>
            <CardContent className="grid grid-cols-1 gap-4">
              <FormField
                disabled={true}
                control={form.control}
                name="companyName"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>{t("Company.company_name")}</FormLabel>
                    <Input {...field} />
                  </FormItem>
                )}
              />

              <FormField
                disabled={true}
                control={form.control}
                name="cocNumber"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>{t("Company.coc_number")}</FormLabel>
                    <Input {...field} />
                  </FormItem>
                )}
              />
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>{t("Company.address_title")}</CardTitle>
              <CardDescription>
                {t("Company.address_description")}
              </CardDescription>
            </CardHeader>
            <CardContent className="grid grid-cols-1 gap-4">
              <div className="grid grid-cols-2 gap-2">
                <FormField
                  control={form.control}
                  name="streetName"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>{t("Company.street_name")}</FormLabel>
                      <Input {...field} />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="streetNumber"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>{t("Company.street_number")}</FormLabel>
                      <Input {...field} />
                    </FormItem>
                  )}
                />
              </div>
              <div className="grid grid-cols-2 gap-2">
                <FormField
                  control={form.control}
                  name="zipCode"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>{t("Company.zip_code")}</FormLabel>
                      <Input {...field} />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="city"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>{t("Company.city")}</FormLabel>
                      <Input {...field} />
                    </FormItem>
                  )}
                />
              </div>

              <FormField
                control={form.control}
                name="country"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>{t("Company.country")}</FormLabel>
                    <Input {...field} />
                  </FormItem>
                )}
              />
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>{t("Company.contact_details_title")}</CardTitle>
              <CardDescription>
                {t("Company.contact_details_description")}
              </CardDescription>
            </CardHeader>
            <CardContent className="grid grid-cols-1 gap-4">
              <div className="grid grid-cols-2 gap-2">
                <FormField
                  control={form.control}
                  name="phone"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>{t("Company.phone")}</FormLabel>
                      <Input {...field} />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="email"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>{t("Company.email")}</FormLabel>
                      <Input {...field} />
                    </FormItem>
                  )}
                />
              </div>

              <FormField
                control={form.control}
                name="website"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>{t("Company.website")}</FormLabel>
                    <Input {...field} />
                  </FormItem>
                )}
              />
            </CardContent>
          </Card>
        </form>
      </Form>
    </>
  );
}
